import * as React from 'react';
import { cn } from '@/utils/cn';

export type IconName = 'BTC' | 'ETH' | 'USDC' | 'USDT-tether' | 'VIP' | 'adventure' | 'age-registration' | 'all-games' | 'animals' | 'another-crypto' | 'apple' | 'applePay' | 'arrow' | 'arrow-back' | 'arrow-down' | 'arrow-down-header' | 'arrow-left' | 'arrow-pagination' | 'arrow-right' | 'arrow-separator' | 'arrow-top' | 'arrow-up' | 'arrows-up-down' | 'asian' | 'attention' | 'auth-facebook' | 'block' | 'buffalo' | 'bundle-bsc-mark' | 'bundle-bsc-mark-gold' | 'bundle-vip-badge' | 'calendar' | 'card' | 'cascading' | 'check' | 'check-main' | 'check2' | 'clock' | 'close' | 'complete' | 'copy' | 'crypto' | 'daily-bonus-bag' | 'daily-bonuses' | 'desktop-logo' | 'download' | 'easter' | 'email' | 'error' | 'etsi_certificate' | 'eye' | 'eye-slash' | 'facebook' | 'fairplay' | 'favorites' | 'footer-apple-pay' | 'footer-cash-app' | 'footer-crypto-icons' | 'footer-google-pay' | 'footer-interac' | 'footer-master-card' | 'footer-pay-pal' | 'footer-visa' | 'free-spins' | 'fruits' | 'fullScreen' | 'gold-coin' | 'google-logo' | 'googlePay' | 'hold&win' | 'independence-day' | 'info' | 'info-payment' | 'instagram' | 'iso_27017_certificate' | 'iso_31000_certificate' | 'kyc-clock' | 'liked' | 'linkedin' | 'live-casino' | 'loading' | 'lobby' | 'lobby-title-arrow' | 'log-out' | 'masterCard' | 'megaways' | 'menu' | 'minus' | 'miss-bonus' | 'missions' | 'mobile-logo' | 'more' | 'more-dots' | 'mystic' | 'myths' | 'new-games' | 'other-category' | 'paper' | 'paypal' | 'pci_certificate' | 'plus' | 'popular-games' | 'profile' | 'promotion' | 'providers' | 'purchases' | 'redeem' | 'responsible' | 'reward' | 'rewards' | 'search' | 'security-safe' | 'settings-sidebar' | 'share' | 'shop' | 'sport' | 'star' | 'success' | 'success-2' | 'support-navbar' | 'sweep-coin' | 'table-games' | 'toast-error' | 'toast-info' | 'toast-success' | 'toast-warning' | 'top-games' | 'top-up' | 'transaction' | 'twitter' | 'unliked' | 'unspread' | 'valentines' | 'verify' | 'virtual-card' | 'visa' | 'warning' | 'warning-payment' | 'x_close' | 'youtube';

export interface SvgProps {
  name: IconName;
  size?: string | number;
  className?: string;
  strokeWidth?: string | number;
  absoluteStrokeWidth?: boolean;
  rtlRotate?: boolean;
  gradientFill?: string;
}

const Icon = (
  { ref, name, size = 20, strokeWidth = 1, absoluteStrokeWidth, className, rtlRotate, gradientFill }: SvgProps & { ref?: React.RefObject<SVGSVGElement | null> },
) => {
  const reactId = React.useId().replace(/:/g, '');

  if (gradientFill) {
    const maskId = `icon-${name}-mask-${reactId}`;
    return (
      <svg
        ref={ref}
        width={size}
        height={size}
        className={cn('ico', rtlRotate && 'rtl:scale-x-[-1]', className)}
        fill="none"
      >
        <mask id={maskId}>
          <g color="#ffffff">
            <use xlinkHref={`#icon-${name}`} />
          </g>
        </mask>
        <rect width="100%" height="100%" fill={gradientFill} mask={`url(#${maskId})`} />
      </svg>
    );
  }

  return (
    <svg
      ref={ref}
      width={size}
      height={size}
      className={cn('ico', rtlRotate && 'rtl:scale-x-[-1]', className)}
      strokeWidth={
        absoluteStrokeWidth
          ? (Number(strokeWidth) * 24) / Number(size)
          : strokeWidth
      }
      name={`#icon-${name}`}
    >
      <use xlinkHref={`#icon-${name}`} />
    </svg>
  );
};

Icon.displayName = 'Icon';
export { Icon };
